import {type ColorHueKey, hues} from '@sanity/color'
import React from 'react'
import {styled} from 'styled-components'

export type ProgressCircleProps = {
  percentage: number
  color: ColorHueKey
  direction: 'clockwise' | 'counter-clockwise'
  size: number
}

const ProgressArc = styled.circle`
  @keyframes strokeProgress {
    from {
      stroke-dashoffset: ${(props) => props.strokeDasharray};
    }
    to {
      stroke-dashoffset: ${(props) => props.strokeDashoffset};
    }
  }

  fill: none;
  stroke-linecap: round;
  animation: 1s ease-out 1;
  transition: stroke-dashoffset 1s ease-out;
`

export const ProgressCircle: React.FC<ProgressCircleProps> = ({
  percentage,
  color,
  direction,
  size,
}) => {
  const strokeWidth = (size / 2) * 0.2
  const radius = size / 2 - strokeWidth // Subtract stroke width for proper sizing
  const circumference = 2 * Math.PI * radius
  const offsetMagnitude = (1 - percentage / 100) * circumference
  const offset = direction === 'clockwise' ? offsetMagnitude : -offsetMagnitude

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background Circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={hues[color][200].hex}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Progress Circle */}
      <ProgressArc
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={hues[color][500].hex}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        strokeLinecap="round"
      />
    </svg>
  )
}
